module.exports = __webpack_public_path__ + "static/media/GUIDE_0009_04.2d908018.webp";